import { render, staticRenderFns } from "./footNav.vue?vue&type=template&id=7d246082"
import script from "./footNav.vue?vue&type=script&lang=js"
export * from "./footNav.vue?vue&type=script&lang=js"
import style0 from "./footNav.vue?vue&type=style&index=0&id=7d246082&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports